var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Spinner } from "core/components/Spinner";
import { content } from "core/utils";
import React from "react";
import styled from "styled-components";
import { NavLink } from "./NavLink";
export var PendingUserBadge = function (_a) {
    var className = _a.className;
    return (React.createElement(Container, { className: className },
        React.createElement(StyledSpinner, null),
        React.createElement(NavLink, { loggedIn: false, disabled: true, label: content.userBadge.loggedOut.navItem.label, "data-gtm": content.userBadge.loggedOut.navItem.gtm, opened: false })));
};
var StyledSpinner = styled(Spinner)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 2rem;\n  height: 2rem;\n  position: absolute;\n  left: -0.375rem;\n  top: -0.25rem;\n"], ["\n  width: 2rem;\n  height: 2rem;\n  position: absolute;\n  left: -0.375rem;\n  top: -0.25rem;\n"])));
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1, templateObject_2;
